module.exports = __webpack_public_path__ + "static/img/ent-detail-24.b4ad845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-24.jpg
// module id = JwCY
// module chunks = 52